const axios = require('axios');
import store from './store'

const api = axios.create({
    baseURL: 'https://n23ao6on11.execute-api.eu-central-1.amazonaws.com/prod/vd',
    timeout: 10000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json', 
        'x-api-key': 'nlPKR4zSEA1wXXuWMvnHsaZxyLkElANk6TSpVGSV'
    }
  });

export default {
    async load(id, secret) {
        return api.post('/load', {
            deviceId: id,
            secretKey: secret
        });
    },
    async loadCredentials(id, secret) {
        return api.post('/loadCredentials', {
            deviceId: id,
            secretKey: secret
        });
    },
    async send(data) {
        if (store.state.deviceId && store.state.deviceSecret)
        {
            return api.post('/send', {
                deviceId: store.state.deviceId,
                secretKey: store.state.deviceSecret,
                data: data
            });
        }
        else
        {
            return false;
        }

        
    }
}                                     